import React from "react";
import { Link } from "react-router-dom";

export function MenuItem(props) {
  const Image = require(`./../assets/img/${props.img}`);
  // the above method should be noted down ---- that damn .default trick
  return (
    <div className="menuItem">
      {/* {Image} */}
      <div className="itemImageContainer">
        <img src={Image} alt="menu item" />
      </div>
      <div className="itemTextContainer">
        <div className="itemName">
          <Link to="/shop">{props.name}</Link>
        </div>
        <div className="itemDetails">{props.details}</div>
        <div className="itemPrice">$ {props.price}</div>
      </div>
    </div>
  );
}
